export const NETWORK_ERROR = 'FETCH_ERROR'

export const VIEW_ONLY_TOAST_TITLE = 'View Only'
export const VIEW_ONLY_TOAST_MESSAGE =
  'You are currently viewing this account with View-Only Permissions. To make changes, you can reach us at support@pavefinance.com'
